import { leaders as leadersVi, leaderCategorys as categorysVi } from './leaderShip.js';
import { leaders as leadersEn, leaderCategorys as categorysEn } from './leaderShip_en.js';

export const allLeaders = {
    vi: { leaders: leadersVi, leaderCategorys: categorysVi },
    en: { leaders: leadersEn, leaderCategorys: categorysEn },
};

export const allLeadersList = {
    vi: leadersVi,
    en: leadersEn,
};

export const allLeaderCategorys = {
    vi: categorysVi,
    en: categorysEn,
};
